import { render, staticRenderFns } from "./TransactionsList.vue?vue&type=template&id=18ab0ccd&scoped=true&"
import script from "./TransactionsList.vue?vue&type=script&lang=js&"
export * from "./TransactionsList.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsList.vue?vue&type=style&index=0&id=18ab0ccd&lang=scss&scoped=true&"
import style1 from "./TransactionsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ab0ccd",
  null
  
)

export default component.exports